import { render } from "./FrequencySettings.vue?vue&type=template&id=f2db3cc8&scoped=true"
import script from "./FrequencySettings.vue?vue&type=script&lang=js"
export * from "./FrequencySettings.vue?vue&type=script&lang=js"

import "./FrequencySettings.vue?vue&type=style&index=0&id=f2db3cc8&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2db3cc8"]])

export default __exports__